import { DOCUMENT } from '@angular/common';
import { Injectable, InjectionToken, inject } from '@angular/core';

/**
 * The single auth-storage touchpoint. The web default uses localStorage; Phase 0.5
 * (the native SwiftUI app keeps its session in the Keychain; this seam stays for tests and future stores)
 * same interface without changing any auth logic.
 */
export interface TokenStore {
  get(): string | null;
  set(token: string): void;
  clear(): void;
}

export const TOKEN_STORE = new InjectionToken<TokenStore>('NB_TOKEN_STORE');

/** Configurable base path for the auth API (default `/api`). */
export const AUTH_API_BASE = new InjectionToken<string>('NB_AUTH_API_BASE', {
  providedIn: 'root',
  factory: () => '/api',
});

/** localStorage-backed token store (web). Guards against blocked/absent storage. */
@Injectable()
export class LocalStorageTokenStore implements TokenStore {
  private static readonly Key = 'nb.accessToken';
  private readonly storage = (() => {
    try {
      return inject(DOCUMENT).defaultView?.localStorage ?? null;
    } catch {
      return null;
    }
  })();

  get(): string | null {
    return this.storage?.getItem(LocalStorageTokenStore.Key) ?? null;
  }

  set(token: string): void {
    this.storage?.setItem(LocalStorageTokenStore.Key, token);
  }

  clear(): void {
    this.storage?.removeItem(LocalStorageTokenStore.Key);
  }
}
